import {
  ScoreGradeCreateInterface,
  ScoreGradeInterface,
  ScoreGradeRepositoryInterface,
} from '@/services/QC-V2/score-grade/interfaces';
import { AxiosInstance } from 'axios';

export default class ScoreGradeRepository implements ScoreGradeRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance,
  ) {
  }

  public async getAll(): Promise<ScoreGradeInterface[]> {
    const response = await this.axios.get('/qa-controller-v2/score/grades');

    return response.data;
  }

  public async getOneById(scoreGradeId: number): Promise<ScoreGradeInterface> {
    const res = await this.axios.get(`/qa-controller-v2/score/grades/${scoreGradeId}`);

    return res.data;
  }

  public async createScoreGrade(data: ScoreGradeCreateInterface): Promise<ScoreGradeInterface> {
    const res = await this.axios.post('/qa-controller-v2/score/grades', data);

    return res.data;
  }

  public async editScoreGrade(id: number, scoreGradeData: ScoreGradeCreateInterface): Promise<void> {
    await this.axios.patch(`/qa-controller-v2/score/grades/${id}`, scoreGradeData);
  }
}
